module.exports = __webpack_public_path__ + "static/img/xiaoxi.d2bc918d.png";